export const AGENT_SANDBOX_BLUEPRINTS = Object.freeze({
    ticket: {
        input: {
            label: 'Ticket ID for test',
            invalidMessage: 'Please enter a valid ticket ID.',
        },
        labels: {
            loadButton: 'Load JSON',
            promptButton: 'Build prompt',
            runButton: 'Run AI',
            inputPanel: 'Show ticket JSON',
            pseudonymizedPanel: 'Show pseudonymized JSON',
            renderedPanel: 'Show rendered prompt',
            rawResultPanel: 'Show AI response with aliases (JSON)',
            finalResultPanel: 'Show AI response with clear names (JSON)',
        },
        loadInputPayload(axiosClient, inputValue) {
            return axiosClient.get('api/workspace/tickets/' + inputValue + '/json');
        },
        runAgent(axiosClient, inputValue, userGroup = null) {
            return axiosClient.post('api/workspace/tickets/ai-assistant', {
                ticket_id: inputValue,
                user_group: userGroup || null,
                include_raw_ai_response: true,
                bypass_cache: true,
            }, {
                timeout: 60000,
            });
        },
    },
});
